import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon in React-Leaflet / Vite
const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

interface MapPickerProps {
  lat: number | null;
  lng: number | null;
  onChange: (lat: number, lng: number) => void;
  height?: string;
}

function LocationMarker({ lat, lng, onChange }: { lat: number; lng: number; onChange: (lat: number, lng: number) => void }) {
  useMapEvents({
    click(e) {
      onChange(e.latlng.lat, e.latlng.lng);
    },
  });

  return <Marker position={[lat, lng]} icon={DefaultIcon} />;
}

export default function MapPicker({ lat, lng, onChange, height = '300px' }: MapPickerProps) {
  const center: [number, number] = lat && lng ? [lat, lng] : [20.5937, 78.9629]; // Default to India center
  const currentLat = lat !== null ? lat : center[0];
  const currentLng = lng !== null ? lng : center[1];

  return (
    <div className="border border-slate-700 rounded-lg overflow-hidden relative" style={{ height }}>
      <MapContainer center={[currentLat, currentLng]} zoom={lat && lng ? 13 : 5} style={{ height: '100%', width: '100%' }} scrollWheelZoom={true}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker lat={currentLat} lng={currentLng} onChange={onChange} />
      </MapContainer>
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-slate-900/90 px-3 py-1 rounded-full text-xs text-slate-300 border border-slate-700 shadow-sm pointer-events-none">
        Click anywhere on the map to update coordinates
      </div>
    </div>
  );
}
